import React, { Component } from "react";
import * as reactDeviceDetect from "react-device-detect";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";
// import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
// import "react-tabs/style/react-tabs.css";
import {
  Button,
  FormGroup,
  // ControlLabel,
  FormControl,
  Form,
} from "react-bootstrap";
import "../../routes/app";
import { fire, auth } from "../../firebase/index";
import * as firebase from "firebase";

//CSS
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import "../../assets/css/account-management.css";

import LocalizedStrings from "react-localization";
import { customLog } from "../../variables/Variables";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    currentPasswordTitle: "Current Password",
    newPasswordTitle: "New Password",
    confirmNewPasswordTitle: "Confirm New Password",
    confirmButton: "Confirm",
    clearAllButton: "Clear All",
    confirmPasswordsAlert:
      "New password and confirm new password does not match",
    enterPasswordsAlert:
      "Please enter your new password and confirm new password",
    minimumLengthAlert: "Password must be at least 6 characters long.",
    enterCurrPasswordAlert: "Please enter your current password",
    passwordUnchangedAlert: "Current password cannot be same as new password",
    checkCurrPasswordAlert: "Please check your current password",
    successfulChangeAlert: "Password changed successfully!",
    loading: "Loading...",
  },
  ja: {
    currentPasswordTitle: "現在のパスワード",
    newPasswordTitle: "新しいパスワード",
    confirmNewPasswordTitle: "新しいパスワードを確認",
    confirmButton: "OK",
    clearAllButton: "クリア",
    confirmPasswordsAlert:
      "新しいパスワードと新しいパスワードの確認が一致しません",
    enterPasswordsAlert:
      "新しいパスワードを入力し、新しいパスワードを確認してください",
    minimumLengthAlert: "パスワードは 6 文字以上である必要があります。",
    enterCurrPasswordAlert: "現在のパスワードを入力してください",
    passwordUnchangedAlert:
      "現在のパスワードを新しいパスワードと同じにすることはできません",
    checkCurrPasswordAlert: "現在のパスワードを確認してください",
    successfulChangeAlert: "パスワードが正常に変更されました",
    loading: "読み込み中...",
  },
  es: {
    currentPasswordTitle: "Contraseña Actual",
    newPasswordTitle: "Nueva Contraseña",
    confirmNewPasswordTitle: "Confirmar Nueva Contraseña",
    confirmButton: "Confirmar",
    clearAllButton: "Limpiar Todo",
    confirmPasswordsAlert:
      "La nueva contraseña y confirmar la nueva contraseña no coincide",
    enterPasswordsAlert:
      "Por favor ingrese su nueva contraseña y confirme la nueva contraseña",
    minimumLengthAlert: "La contraseña debe tener al menos 6 caracteres.",
    enterCurrPasswordAlert: "Por favor ingrese su contraseña actual",
    passwordUnchangedAlert:
      "La contraseña actual no puede ser la misma que la nueva contraseña",
    checkCurrPasswordAlert: "Por favor verifique su contraseña actual",
    successfulChangeAlert: "¡La contraseña se cambió correctamente!",
    loading: "Cargando...",
  },
});

export class ResetPassword extends Component {
  constructor(props) {
    super(props);
    // this.currentpasswordChange = this.currentpasswordChange.bind(this);
    this.changePW = this.changePW.bind(this);
    this.curPassword = this.curPassword.bind(this);
    this.newPassword = this.newPassword.bind(this);
    this.cfmPassword = this.cfmPassword.bind(this);
    this.clearAll = this.clearAll.bind(this);
    this.state = {
      passwordOne: "",
      passwordTwo: "",
      myName: "",
      myEmail: "",
      currentPassword: "",
      _notificationSystem: null,
      loading: false,
    };
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    fire
      .database()
      .ref("registeredIndustrialUsersOnPlatform")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          var name = "";
          var email = "";

          snapshot.forEach((childSnapshot) => {
            if (childSnapshot.key === "name") {
              name = childSnapshot.val();
            } else if (childSnapshot.key === "email") {
              email = childSnapshot.val();
            }
          });
          this.setState({
            myName: name,
            myEmail: email,
          });
        }
      });

    //! GET LANGUAGE SETTINGS
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });
  }

  getDeviceDetails = () => {
    let browser = "";
    let device = "";
    let version = "";
    if (reactDeviceDetect.isMobile) {
      device = reactDeviceDetect.mobileModel;
      browser = reactDeviceDetect.browserName;
      version = reactDeviceDetect.fullBrowserVersion;
    } else if (reactDeviceDetect.isDesktop) {
      device = reactDeviceDetect.osName;
      browser = reactDeviceDetect.browserName;
      version = reactDeviceDetect.fullBrowserVersion;
    }

    return device + " using " + browser + ", version " + version;
  };

  saveActivityLogs() {
    // const activityLogsDB = fire.database().ref("activityLogs").child(auth.currentUser.uid);
    // const key = activityLogsDB.push().key;

    let activityLogsDB = fire
      .database()
      .ref("individualActivities")
      .child(auth.currentUser.uid);
    let activityKey = activityLogsDB.push().key;

    // check through all superadmins in groupAccounts
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superadminUID = superAdmin.key;

            // if user is superadmin
            if (superadminUID === auth.currentUser.uid) {
              // add into activityLogs of the superAdmins's activity
              fire
                .database()
                .ref("individualActivities")
                .child(auth.currentUser.uid) // get uid from auth person object
                .child(activityKey)
                .set({
                  activityType: 7,
                  description: auth.currentUser.email,
                  detailedDescription: "",
                  // isRead: false,
                  userEmail: auth.currentUser.email,
                  platform: "Web App",
                  userUID: auth.currentUser.uid,
                  snapKey: activityKey,
                  timeStamp: Math.floor(new Date()),

                  // activity: 7,
                  // Type: 0,
                  // description: 'Account password reset/change',
                  // email: auth.currentUser.email,
                  // time: Math.floor(new Date() / 1000),
                  // userUID: auth.currentUser.uid,
                  // device: this.getDeviceDetails()
                });

              // alert("Password changed!!!");
              // document.location.reload();
              this.showNotification(
                `${localizationStrings.successfulChangeAlert}`,
                "success",
                3
              );
              this.setState({
                passwordOne: "",
                passwordTwo: "",
                currentPassword: "",
              });
              this.setState({ loading: false });
            } else {
              // console.log("Checking if user is under super admin");
              // check if user is under the super admin
              fire
                .database()
                .ref("groupAccounts")
                .child(superadminUID)
                .child("members")
                .once("value")
                .then((snapshot) => {
                  if (snapshot.exists()) {
                    snapshot.forEach((member) => {
                      // get member details
                      fire
                        .database()
                        .ref("groupAccounts")
                        .child(superadminUID)
                        .child("members")
                        .child(member.key)
                        .once("value")
                        .then((memberDetail) => {
                          if (memberDetail.exists()) {
                            let member = memberDetail.val();
                            if (member.memberEmail === auth.currentUser.email) {
                              if (member.isAdmin === true) {
                                // add into activityLogs of the admin's activity
                                fire
                                  .database()
                                  .ref("individualActivities")
                                  .child(auth.currentUser.uid) // get uid from auth person object
                                  .child(activityKey)
                                  .set({
                                    activityType: 7,
                                    description: auth.currentUser.email,
                                    detailedDescription: "",
                                    // isRead: false,
                                    userEmail: auth.currentUser.email,
                                    platform: "Web App",
                                    userUID: auth.currentUser.uid,
                                    snapKey: activityKey,
                                    timeStamp: Math.floor(new Date()),
                                  });

                                // alert("Password changed!!!");
                                // document.location.reload();
                                this.showNotification(
                                  `${localizationStrings.successfulChangeAlert}`,
                                  "success",
                                  3
                                );
                                this.setState({
                                  passwordOne: "",
                                  passwordTwo: "",
                                  currentPassword: "",
                                });
                                this.setState({ loading: false });
                              } else {
                                this.showNotification(
                                  `${localizationStrings.successfulChangeAlert}`,
                                  "success",
                                  3
                                );
                                this.setState({
                                  passwordOne: "",
                                  passwordTwo: "",
                                  currentPassword: "",
                                });
                                this.setState({ loading: false });
                              }
                            }
                          }
                        });
                    });
                  }
                });
            }
          });
        }
      });
  }

  changePWOld(newpassword) {
    this.setState({ loading: true });
    if (this.state.currentPassword === "") {
      // alert("Please enter your Current Password!");
      this.showNotification(
        `${localizationStrings.enterCurrPasswordAlert}`,
        "error",
        3
      );
      this.setState({ loading: false });
    } else {
      this.reAuthenticate(this.state.currentPassword)
        .then(() => {
          if (this.state.currentPassword === newpassword) {
            // alert("Sorry, Current Password cannot be same as New Password");
            this.showNotification(
              `${localizationStrings.passwordUnchangedAlert}`,
              "error",
              3
            );
            this.setState({ loading: false });
          } else {
            var user = auth.currentUser;

            user
              .updatePassword(newpassword)
              .then(() => {
                this.saveActivityLogs();
                // alert("Password changed!!!");
                // document.location.reload();
              })
              .catch((error) => {
                this.setState({ loading: false });
              });
          }
        })
        .catch(() => {
          // alert("Sorry, please check your Current Password again!");
          this.showNotification(
            `${localizationStrings.checkCurrPasswordAlert}`,
            "error",
            3
          );
          this.setState({ loading: false });
        });
    }
  }

  changePW(newpassword) {
    this.setState({ loading: true });

    if (this.state.currentPassword === "") {
      this.showNotification(
        `${localizationStrings.enterCurrPasswordAlert}`,
        "error",
        3
      );
      this.setState({ loading: false });
      return;
    }

    this.reAuthenticate(this.state.currentPassword)
      .then(() => {
        if (this.state.currentPassword === newpassword) {
          this.showNotification(
            `${localizationStrings.passwordUnchangedAlert}`,
            "error",
            3
          );
          this.setState({ loading: false });
          return;
        }

        const user = auth.currentUser;

        user
          .updatePassword(newpassword)
          .then(() => {
            // ✅ Always show success message
            this.showNotification(
              `${localizationStrings.successfulChangeAlert}`,
              "success",
              3
            );
            this.setState({
              passwordOne: "",
              passwordTwo: "",
              currentPassword: "",
              loading: false,
            });

            // 📝 Log activity only if authorized
            this.checkIfAuthorizedToLogActivity();
          })
          .catch((error) => {
            this.setState({ loading: false });
          });
      })
      .catch(() => {
        this.showNotification(
          `${localizationStrings.checkCurrPasswordAlert}`,
          "error",
          3
        );
        this.setState({ loading: false });
      });
  }

  checkIfAuthorizedToLogActivity() {
    const currentUID = auth.currentUser.uid;
    const currentEmail = auth.currentUser.email;
    const activityLogsDB = fire
      .database()
      .ref("individualActivities")
      .child(currentUID);
    const activityKey = activityLogsDB.push().key;

    let foundAuthorized = false;
    let checksPending = 0;

    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (!snapshot.exists()) return;

        const superAdmins = snapshot.val();
        const superAdminKeys = Object.keys(superAdmins);
        const totalChecks = superAdminKeys.length;

        superAdminKeys.forEach((superadminUID) => {
          if (superadminUID === currentUID) {
            // 🧑‍💼 Superadmin
            foundAuthorized = true;
            this.logActivity(activityLogsDB, activityKey);
          } else {
            // 🔍 Check group members
            fire
              .database()
              .ref("groupAccounts")
              .child(superadminUID)
              .child("members")
              .once("value")
              .then((membersSnap) => {
                if (membersSnap.exists()) {
                  const members = membersSnap.val();
                  for (const memberId in members) {
                    const member = members[memberId];
                    if (
                      member.memberEmail === currentEmail &&
                      member.isAdmin === true
                    ) {
                      foundAuthorized = true;
                      this.logActivity(activityLogsDB, activityKey);
                      break;
                    }
                  }
                }
              })
              .finally(() => {
                checksPending++;
                if (checksPending === totalChecks && !foundAuthorized) {
                  customLog(
                    "User not authorized to log activity. No logging needed."
                  );
                }
              });
          }
        });
      });
  }

  logActivity(activityLogsDB, activityKey) {
    activityLogsDB.child(activityKey).set({
      activityType: 7,
      description: auth.currentUser.email,
      detailedDescription: "",
      userEmail: auth.currentUser.email,
      platform: "Web App",
      userUID: auth.currentUser.uid,
      snapKey: activityKey,
      timeStamp: Math.floor(new Date()),
    });
  }

  curPassword(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      document.getElementById("newpassword").focus();
    }
  }

  newPassword(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      document.getElementById("cfmpassword").focus();
    }
  }

  cfmPassword(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      document.getElementById("btnSearch").click();
    }
  }

  clearAll() {
    this.setState({
      passwordOne: "",
      passwordTwo: "",
      currentPassword: "",
    });
  }

  reAuthenticate = (currentPassword) => {
    var user = auth.currentUser;
    var cred = firebase.auth.EmailAuthProvider.credential(
      user.email,
      currentPassword
    );
    return user.reauthenticateWithCredential(cred);
  };
  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div
        style={{ maxWidth: "500px", marginRight: "auto", marginLeft: "auto" }}
      >
        <NotificationSystem ref="notificationSystem" style={style} />
        <br />
        <br />
        <Form>
          <FormGroup>
            <table className={"accManagementTable"}>
              <tbody>
                <tr>
                  {/* <td>
                    <ControlLabel
                      style={{
                        whiteSpace: "nowrap",
                        width: "60%",
                        fontSize: "18px"
                      }}
                    >
                      {localizationStrings.currentPasswordTitle}:
                    </ControlLabel>
                  </td> */}
                  <td>
                    <FormControl
                      type="password"
                      id="currentpassword"
                      name="currentpassword"
                      className="passwordInput"
                      placeholder={localizationStrings.currentPasswordTitle}
                      onChange={(event) =>
                        this.setState({ currentPassword: event.target.value })
                      }
                      onKeyUp={this.curPassword}
                      value={this.state.currentPassword}
                    />
                  </td>
                </tr>
                <tr>
                  {/* <td>
                    <ControlLabel
                      style={{
                        whiteSpace: "nowrap",
                        width: "60%",
                        fontSize: "18px"
                      }}
                    >
                      {localizationStrings.newPasswordTitle}:
                    </ControlLabel>
                  </td> */}
                  <td>
                    <FormControl
                      type="password"
                      id="newpassword"
                      name="newpassword"
                      className="passwordInput"
                      placeholder={localizationStrings.newPasswordTitle}
                      onChange={(event) =>
                        this.setState({ passwordOne: event.target.value })
                      }
                      onKeyUp={this.newPassword}
                      value={this.state.passwordOne}
                    />
                  </td>
                </tr>
                <tr>
                  {/* <td>
                    <ControlLabel
                      style={{
                        whiteSpace: "nowrap",
                        width: "60%",
                        fontSize: "18px"
                      }}
                    >
                      {localizationStrings.confirmNewPasswordTitle}:
                    </ControlLabel>
                  </td> */}
                  <td>
                    <FormControl
                      type="password"
                      id="cfmpassword"
                      name="cfmpassword"
                      className="passwordInput"
                      placeholder={localizationStrings.confirmNewPasswordTitle}
                      onChange={(event) =>
                        this.setState({ passwordTwo: event.target.value })
                      }
                      onKeyUp={this.cfmPassword}
                      value={this.state.passwordTwo}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Button
                      id="btnSearch"
                      className="loginsignupbutton"
                      disabled={this.state.loading}
                      onClick={() => {
                        if (this.state.passwordOne !== this.state.passwordTwo) {
                          // alert(localizationStrings.confirmPasswordsAlert);
                          this.showNotification(
                            `${localizationStrings.confirmPasswordsAlert}`,
                            "error",
                            3
                          );
                        } else if (
                          this.state.passwordOne === "" &&
                          this.state.passwordTwo === ""
                        ) {
                          // alert(localizationStrings.enterPasswordsAlert);
                          this.showNotification(
                            `${localizationStrings.enterPasswordsAlert}`,
                            "error",
                            3
                          );
                        } else if (this.state.passwordOne.length < 6) {
                          this.showNotification(
                            `${localizationStrings.minimumLengthAlert}`,
                            "error",
                            3
                          );
                        } else {
                          this.changePW(this.state.passwordOne);
                        }
                      }}
                    >
                      {this.state.loading
                        ? localizationStrings.loading
                        : localizationStrings.confirmButton}
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td>
                    {/* <Button type="reset" className={"clearSendBtn"}>
                      {localizationStrings.clearAllButton}
                    </Button> */}
                    <Button
                      style={{ marginTop: "unset !important" }}
                      className={"clearSendBtn"}
                      onClick={this.clearAll}
                    >
                      {localizationStrings.clearAllButton}
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
            {/* <div style={{ display: "flex" }}>
                                <ControlLabel style={{ whiteSpace: "nowrap", width: "60%", fontSize: "18px" }}>Current Password:</ControlLabel>
                                <FormControl type="password" id="currentpassword" name="currentpassword"
                                    onChange={event => this.setState({ currentPassword: event.target.value })} 
                                    onKeyUp={this.curPassword}/>
                            </div><br />
                            <div style={{ display: "flex" }}>
                                <ControlLabel style={{ whiteSpace: "nowrap", width: "60%", fontSize: "18px" }}>New Password:</ControlLabel>
                                <FormControl type="password" id="newpassword" name="newpassword"
                                    onChange={event => this.setState({ passwordOne: event.target.value })}
                                    onKeyUp={this.newPassword}/>
                            </div><br />
                            <div style={{ display: "flex" }}>
                                <ControlLabel style={{ whiteSpace: "nowrap", width: "60%", fontSize: "18px" }}>Confirm New Password:</ControlLabel>
                                <FormControl type="password" id="cfmpassword" name="cfmpassword"
                                    onChange={event => this.setState({ passwordTwo: event.target.value })}
                                    onKeyUp={this.cfmPassword}/>
                            </div><br />
                            <div style={{ display: "flex" }}>
                                <div style={{ width: "50%", marginTop: "20px", marginLeft: "5px" }}>
                                    <Button
                                        id="btnSearch"
                                        className="btn btn-primary btn-fill"
                                        style={{ width: "100%" }}
                                        onClick={() => {
                                            if (this.state.passwordOne !== this.state.passwordTwo) {
                                                alert('New Password and Confirm New Password do not match!')
                                            }else if(this.state.passwordOne === "" && this.state.passwordTwo === ""){
                                                alert("Please enter your New Password and Confirm New Password!")
                                            } 
                                            else {
                                                this.changePW(this.state.passwordOne)
                                            }
                                        }}
                                    >
                                        Confirm <small>確かめます</small>
                                    </Button>
                                </div>
                                <Button style={{ width: "50%", marginTop: "20px", marginLeft: "5px" }}
                                    type="reset"
                                >
                                    Clear All <small>クリア</small>
                                </Button>
                            </div> */}
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default ResetPassword;
